const contractFeesText = {
  summary:
    'Contract fees can reduce the amount of interest credited, including amounts intended to offset administrative expenses',
  headline:
    'Contract fees have the effect of reducing the amount of interest credited.',
  body: `Contract fees include amounts intended to offset record keeping and administrative expenses, as well as other contract-specific
  charges that may apply. The deduction of contract fees may result in your accumulation growing at a rate that is less than
  the minimum guaranteed interest rate. However, the value of your account will never decrease, even after contract fees have
  been deducted. `
};
export default contractFeesText;
